import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { StyledInput } from './TextFieldStyled';

const CustomizedInputs = ({ type, id, label, htmlFor, placeholder, handelChange, value }) => {
  return (
    <StyledInput>
      <FormControl variant="standard">
        <InputLabel shrink htmlFor={htmlFor}>
          {label}
        </InputLabel>
        <input type={type} onChange={handelChange} value={value}
          defaultValue="" id={id} placeholder={placeholder} />
      </FormControl>
    </StyledInput>
  );
}

export default CustomizedInputs

CustomizedInputs.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  htmlFor: PropTypes.string,
  value: PropTypes.string,
};

CustomizedInputs.defaultProps = {
  type: 'input'
};